import { isNative } from '../platform/capacitor';
import { storageGet, storageSet } from '../platform/storage';
import { v2Request } from './client';

export const isLikelyApnsToken = (tokenValue) =>
  typeof tokenValue === 'string' && /^[a-f0-9]{64}$/i.test(tokenValue.trim());

const SYNC_TOKEN_KEY = 'v2_push_sync_token';
const SYNC_MOBILE_KEY = 'v2_push_sync_mobile';
const NEPTUNE_TOKEN_KEY = 'v2_push_neptune_token';

function normalizeMobile(raw) {
  return String(raw || '').replace(/\D/g, '').slice(-10);
}

/** @param {{ deviceToken: string, mobile?: string }} body */
export function syncPushTokenToBackend({ deviceToken, mobile }) {
  const payload = { deviceToken };
  const digits = mobile != null ? normalizeMobile(mobile) : '';
  if (digits.length === 10) payload.mobile = digits;
  return v2Request('/api/auth/device-token', {
    method: 'POST',
    body: payload,
  });
}

/**
 * Sync FCM token to Pilot (native only). Guest = NEPTUNE only; logged-in = NEPTUNE + user doc.
 * @param {{ deviceToken: string, mobile?: string }} params
 */
export async function syncPushTokenIfNeeded({ deviceToken, mobile }) {
  if (!isNative() || !deviceToken) return;
  if (isLikelyApnsToken(deviceToken)) return;

  const digits = mobile != null ? normalizeMobile(mobile) : '';
  const isLoggedIn = digits.length === 10;

  if (isLoggedIn) {
    const lastToken = await storageGet(SYNC_TOKEN_KEY);
    const lastMobile = await storageGet(SYNC_MOBILE_KEY);
    if (lastToken === deviceToken && lastMobile === digits) return;
  } else {
    const lastNeptune = await storageGet(NEPTUNE_TOKEN_KEY);
    if (lastNeptune === deviceToken) return;
  }

  try {
    await syncPushTokenToBackend({
      deviceToken,
      mobile: isLoggedIn ? digits : undefined,
    });
    await storageSet(NEPTUNE_TOKEN_KEY, deviceToken);
    if (isLoggedIn) {
      await storageSet(SYNC_TOKEN_KEY, deviceToken);
      await storageSet(SYNC_MOBILE_KEY, digits);
    }
  } catch (err) {
    console.warn('[v2] push token sync failed', err?.message || err);
  }
}
